export enum NotificationStatus {
    Created = 10,
    SendFailed = 20,
    Sent = 30,
    Accepted = 40,
    Delivered = 50,
    Undeliverable = 60,

    NoFirebaseToken = 100,
    ServiceUnavailable = 200,
}

export const enumLabel = (value?: NotificationStatus) => {
    switch (value) {
        case NotificationStatus.Created:
            return 'Создано';
        case NotificationStatus.SendFailed:
            return 'Ошибка отправки';
        case NotificationStatus.Sent:
            return 'Отправлено';
        case NotificationStatus.Accepted:
            return 'Принято';
        case NotificationStatus.Delivered:
            return 'Доставлено';
        case NotificationStatus.Undeliverable:
            return 'Не доставлено';

        case NotificationStatus.NoFirebaseToken:
            return 'Нет приложения';
        case NotificationStatus.ServiceUnavailable:
            return 'Сервис недоступен';
        default:
            return '';
    }
};
